import React from "react";

import type { BasicIconProps as IconProps } from "./Icon";
import { IconWrapper } from "./Icon";

type BaseTabBarIcon = (props: IconProps) => React.ReactElement<any>;

export interface TabBarIcon extends BaseTabBarIcon {
  Filled: BaseTabBarIcon;
  Outline: BaseTabBarIcon;
}

export const HomeIcon: TabBarIcon = (props: IconProps) => (
  <IconWrapper size={32} viewBox="0 0 32 32" {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.876 5.089l-7 5.563A4.955 4.955 0 004 14.531v8.502C4 25.776 6.239 28 9 28h14c2.761 0 5-2.224 5-4.967V14.53c0-1.508-.69-2.935-1.877-3.878l-7-5.563a5.026 5.026 0 00-6.247 0zM6 14.53c0-.905.414-1.762 1.126-2.327l7-5.564a3.015 3.015 0 013.748 0l7 5.563A2.973 2.973 0 0126 14.531v8.502a2.99 2.99 0 01-3 2.98H9a2.99 2.99 0 01-3-2.98V14.53zm5.679 3.485a1.005 1.005 0 00-1.414 0 .989.989 0 000 1.405c3.254 3.233 8.53 3.233 11.785 0a.989.989 0 000-1.405 1.005 1.005 0 00-1.414 0 6.363 6.363 0 01-8.957 0z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

HomeIcon.Outline = HomeIcon;

HomeIcon.Filled = (props: IconProps) => (
  <IconWrapper size={32} viewBox="0 0 32 32" {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.876 10.652l7-5.563a5.026 5.026 0 016.248 0l7 5.563A4.955 4.955 0 0128 14.53v8.503C28 25.776 25.76 28 23 28H9c-2.761 0-5-2.224-5-4.967V14.53c0-1.51.69-2.936 1.876-3.879zm5.803 7.364a1.005 1.005 0 00-1.414 0 .989.989 0 000 1.405c3.254 3.233 8.53 3.233 11.785 0a.989.989 0 000-1.405 1.005 1.005 0 00-1.414 0 6.363 6.363 0 01-8.957 0z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const SearchIcon = (props: IconProps) => (
  <IconWrapper size={32} viewBox="0 0 32 32" {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 14a7 7 0 1114 0 7 7 0 01-14 0zm7-9a9 9 0 105.618 16.032l5.675 5.675a1 1 0 001.414-1.414l-5.675-5.675A9 9 0 0014 5z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

SearchIcon.Outline = SearchIcon;

SearchIcon.Filled = (props: IconProps) => (
  <IconWrapper size={32} viewBox="0 0 32 32" {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.654 21.482a9.5 9.5 0 112.828-2.828l5.432 5.432a2 2 0 11-2.828 2.828l-5.432-5.432zM13.5 20a6.5 6.5 0 100-13 6.5 6.5 0 000 13z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

SearchIcon.Small = (props: IconProps) => (
  <IconWrapper size={24} viewBox="0 0 24 24" {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 4a7 7 0 104.192 12.606l4.1 4.101a1 1 0 001.415-1.414l-4.1-4.1A7 7 0 0011 4zm-5 7a5 5 0 1110 0 5 5 0 01-10 0z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const BibleIcon = (props: IconProps) => (
  <IconWrapper size={32} viewBox="0 0 32 32" {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 10a6 6 0 016-6h12a6 6 0 016 6v12a6 6 0 01-6 6H10a5.99 5.99 0 01-2.027-.351l-.013-.005A6.002 6.002 0 014 22V10zm5.897 15.999a3.992 3.992 0 01-1.142-.197A1.5 1.5 0 019.5 23H22a5.978 5.978 0 004-1.528V22a4 4 0 01-4 4H10l-.103-.001zM26 17a4 4 0 01-4 4H9.5a3.501 3.501 0 00-3.286 2.293A3.995 3.995 0 016 22V10a4 4 0 014-4h12a4 4 0 014 4v7zM16 9a1 1 0 011 1v1.5h1.5a1 1 0 110 2H17V17a1 1 0 11-2 0v-3.5h-1.5a1 1 0 110-2H15V10a1 1 0 011-1z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

BibleIcon.Outline = BibleIcon;

BibleIcon.Filled = (props: IconProps) => (
  <IconWrapper size={32} viewBox="0 0 32 32" {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 4a6 6 0 00-6 6v12a6 6 0 006 6h12a6 6 0 006-6V10a6 6 0 00-6-6H10zm6 5a1 1 0 011 1v1.5h1.5a1 1 0 110 2H17V17a1 1 0 11-2 0v-3.5h-1.5a1 1 0 110-2H15V10a1 1 0 011-1zm6 14a5.978 5.978 0 004-1.528V22a4 4 0 01-4 4H10c-.436 0-.853-.07-1.244-.197A1.5 1.5 0 019.5 23H22z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const CommunityIcon = (props: IconProps) => (
  <IconWrapper size={32} viewBox="0 0 32 32" {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.494 5.625a2.885 2.885 0 00-3.588 0l-2.625 2.087a2.858 2.858 0 00-1.08 2.237l-.001 3.188A2.869 2.869 0 0013.075 16h5.25a2.869 2.869 0 002.875-2.863V9.95c0-.872-.4-1.695-1.081-2.237l-2.625-2.087zM15.15 7.191a.885.885 0 011.098 0l2.625 2.086a.858.858 0 01.326.672v3.188c0 .47-.386.863-.875.863h-5.25a.869.869 0 01-.875-.863V9.95c0-.26.119-.507.326-.672l2.625-2.086zM7.706 17.625a2.884 2.884 0 013.588 0l2.624 2.087A2.858 2.858 0 0115 21.949v3.188A2.869 2.869 0 0112.125 28h-5.25A2.869 2.869 0 014 25.137V21.95c0-.872.4-1.695 1.081-2.237l2.625-2.087zm2.343 1.566a.884.884 0 00-1.098 0l-2.625 2.086A.858.858 0 006 21.95v3.188c0 .47.386.863.875.863h5.25c.49 0 .875-.392.875-.863V21.95a.858.858 0 00-.326-.672l-2.625-2.086zm14.245-1.566a2.884 2.884 0 00-3.588 0l-2.625 2.087A2.858 2.858 0 0017 21.949v3.188A2.869 2.869 0 0019.875 28h5.25A2.869 2.869 0 0028 25.137V21.95c0-.872-.4-1.695-1.082-2.237l-2.624-2.087zm-2.343 1.566a.884.884 0 011.098 0l2.625 2.086a.858.858 0 01.326.672v3.188c0 .47-.386.863-.875.863h-5.25a.869.869 0 01-.875-.863V21.95c0-.26.119-.507.326-.672l2.625-2.086z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

CommunityIcon.Outline = CommunityIcon;

CommunityIcon.Filled = (props: IconProps) => (
  <IconWrapper size={32} viewBox="0 0 32 32" {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.494 4.625a2.885 2.885 0 00-3.588 0l-2.625 2.087a2.858 2.858 0 00-1.08 2.237l-.001 3.188A2.869 2.869 0 0013.075 15h5.25a2.869 2.869 0 002.875-2.863V8.95c0-.872-.4-1.695-1.081-2.237l-2.625-2.087zm-6.2 12a2.884 2.884 0 00-3.588 0l-2.625 2.087A2.858 2.858 0 004 20.949v3.188A2.869 2.869 0 006.875 27h5.25A2.869 2.869 0 0015 24.137V20.95c0-.872-.4-1.695-1.082-2.237l-2.624-2.087zm13 0a2.884 2.884 0 00-3.588 0l-2.625 2.087A2.858 2.858 0 0017 20.949v3.188A2.869 2.869 0 0019.875 27h5.25A2.869 2.869 0 0028 24.137V20.95c0-.872-.4-1.695-1.082-2.237l-2.624-2.087z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const Community2Icon = {
  Outline: (props: IconProps) => (
    <IconWrapper viewBox="0 0 32 32" stroke="currentColor" {...props}>
      <svg>
        <g mask="url(#path-7-outside-1_13154_5)">
          <circle
            cx="10"
            cy="9"
            r="3"
            fill="none"
            stroke={props.fill}
            strokeWidth="2"
          />
          <circle
            cx="22"
            cy="9"
            r="3"
            fill="none"
            stroke={props.fill}
            strokeWidth="2"
          />
          <circle
            cx="16"
            cy="16"
            r="3"
            fill="none"
            stroke={props.fill}
            strokeWidth="2"
          />
          <path
            d="M16 19C13.2386 19 11 21 11 27H21C21 21 18.7614 19 16 19Z"
            stroke={props.fill}
            strokeWidth="2"
            strokeLinejoin="round"
            fill="none"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.9768 19C25.8657 16.6853 25.3661 15.2213 24.7255 14.3364C24.0364 13.3845 23.1104 13 22 13C20.8896 13 19.9636 13.3845 19.2745 14.3364C18.6339 15.2213 18.1343 16.6853 18.0232 19H25.9768ZM17.6544 13.1636C18.775 11.6155 20.349 11 22 11C23.6511 11 25.225 11.6155 26.3456 13.1636C27.4269 14.6574 28 16.9026 28 20C28 20.5523 27.5523 21 27 21H20.7054C19.7906 19.5662 18.4693 19 17 19C16.6636 19 16.335 19.0297 16.0173 19.0926C16.0321 18.7137 16.0564 18.3489 16.0901 17.998C17.1528 17.9509 18 17.0744 18 16C18 15.2635 17.6019 14.62 17.0091 14.2729C17.1986 13.8652 17.4139 13.4958 17.6544 13.1636Z"
            fill={props.fill}
            stroke="none"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.9119 18.1148C13.7293 16.3035 13.2803 15.1028 12.7255 14.3364C12.0364 13.3845 11.1104 13 10 13C8.88963 13 7.96356 13.3845 7.27452 14.3364C6.63392 15.2213 6.13427 16.6853 6.02315 19H12.145C11.6028 19.4718 11.1391 20.1271 10.7829 21H5C4.44772 21 4 20.5523 4 20C4 16.9026 4.57314 14.6574 5.65442 13.1636C6.77502 11.6155 8.34895 11 10 11C11.651 11 13.225 11.6155 14.3456 13.1636C14.5861 13.4958 14.8014 13.8652 14.9909 14.2729C14.3981 14.62 14 15.2635 14 16C14 17.0744 14.8472 17.9509 15.9099 17.998C15.9126 18.0253 15.9151 18.0527 15.9176 18.0802C15.6202 18.0258 15.3135 18 15 18C14.6263 18 14.2622 18.0366 13.9119 18.1148Z"
            fill={props.fill}
            stroke="none"
          />
        </g>
        <mask
          id="path-7-outside-1_13154_5"
          maskUnits="userSpaceOnUse"
          fill="black"
          stroke="none"
        >
          <rect fill="white" x="0" y="0" width="100%" height="100%" />
          <path
            d="M18.8789 18.777L17.7995 17.7355L16.512 19.0699L18.0859 20.0502L18.8789 18.777ZM20.3456 20.1636L19.1305 21.0432L20.3456 20.1636ZM11.6544 20.1636L10.4393 19.2841L11.6544 20.1636ZM13.1211 18.777L13.9141 20.0502L15.488 19.0699L14.2005 17.7355L13.1211 18.777ZM16 10.5C12.9624 10.5 10.5 12.9624 10.5 16H13.5C13.5 14.6193 14.6193 13.5 16 13.5V10.5ZM21.5 16C21.5 12.9624 19.0376 10.5 16 10.5V13.5C17.3807 13.5 18.5 14.6193 18.5 16H21.5ZM19.9584 19.8185C20.9114 18.8307 21.5 17.4825 21.5 16H18.5C18.5 16.6747 18.2347 17.2844 17.7995 17.7355L19.9584 19.8185ZM18.0859 20.0502C18.4567 20.2812 18.811 20.6018 19.1305 21.0432L21.5607 19.2841C21.0214 18.5391 20.3838 17.9472 19.672 17.5038L18.0859 20.0502ZM19.1305 21.0432C19.947 22.1712 20.5 24.0485 20.5 27H23.5C23.5 23.7567 22.9067 21.1436 21.5607 19.2841L19.1305 21.0432ZM20.5 27C20.5 26.7239 20.7239 26.5 21 26.5V29.5C22.3807 29.5 23.5 28.3807 23.5 27H20.5ZM21 26.5H11V29.5H21V26.5ZM11 26.5C11.2761 26.5 11.5 26.7239 11.5 27H8.5C8.5 28.3807 9.61929 29.5 11 29.5V26.5ZM11.5 27C11.5 24.0485 12.053 22.1712 12.8695 21.0432L10.4393 19.2841C9.09332 21.1436 8.5 23.7567 8.5 27H11.5ZM12.8695 21.0432C13.189 20.6018 13.5433 20.2812 13.9141 20.0502L12.328 17.5038C11.6162 17.9472 10.9786 18.5391 10.4393 19.2841L12.8695 21.0432ZM10.5 16C10.5 17.4825 11.0886 18.8307 12.0416 19.8185L14.2005 17.7355C13.7653 17.2844 13.5 16.6747 13.5 16H10.5Z"
            mask="url(#path-7-outside-1_13154_6)"
          />
        </mask>
        <mask
          id="path-7-outside-1_13154_6"
          maskUnits="userSpaceOnUse"
          x="8"
          y="10"
          width="16"
          height="20"
          fill="black"
        >
          <rect fill="white" x="8" y="10" width="16" height="20" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 16C12 13.7909 13.7909 12 16 12C18.2091 12 20 13.7909 20 16C20 17.0786 19.5731 18.0576 18.8789 18.777C19.4203 19.1142 19.9162 19.5705 20.3456 20.1636C21.4269 21.6574 22 23.9026 22 27C22 27.5523 21.5523 28 21 28H11C10.4477 28 10 27.5523 10 27C10 23.9026 10.5731 21.6574 11.6544 20.1636C12.0838 19.5705 12.5797 19.1142 13.1211 18.777C12.4269 18.0576 12 17.0786 12 16Z"
            stroke="none"
          />
        </mask>
      </svg>
    </IconWrapper>
  ),
  Filled: (props: IconProps) => (
    <IconWrapper viewBox="0 0 32 32" stroke="currentColor" {...props}>
      <svg>
        <g mask="url(#path-6-outside-1_13154_5)">
          <circle
            cx="10"
            cy="9"
            r="3"
            fill={props.fill}
            stroke={props.fill}
            strokeWidth="2"
          />
          <circle
            cx="22"
            cy="9"
            r="3"
            fill={props.fill}
            stroke={props.fill}
            strokeWidth="2"
          />
          <path
            d="M16 19C13.2386 19 11 21 11 27H21C21 21 18.7614 19 16 19Z"
            fill="none"
            stroke={props.fill}
            strokeWidth="2"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.7021 13.9492C18.3509 13.3817 18.0839 12.5747 18.5997 12.1512C19.5874 11.3403 20.7724 11 22 11C23.6511 11 25.225 11.6155 26.3456 13.1636C27.4269 14.6574 28 16.9026 28 20C28 20.5523 27.5523 21 27 21H21.2171C20.3291 18.8238 18.7722 18 17 18C16.6866 18 16.3798 18.0258 16.0824 18.0802C16.0966 17.9244 16.1126 17.7713 16.1305 17.6209C16.1775 17.2246 16.6009 17 17 17C18.1046 17 19 16.1046 19 15C19 14.6146 18.891 14.2546 18.7021 13.9492Z"
            fill={props.fill}
            stroke="none"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.65442 13.1636C6.77502 11.6155 8.34895 11 10 11C11.6357 11 13.1957 11.6041 14.3142 13.1207C13.5474 13.4006 13 14.1364 13 15C13 16.1046 13.8954 17 15 17C15.2685 17 15.5246 16.9471 15.7585 16.8512C15.8253 17.2405 15.8784 17.65 15.9176 18.0802C15.6202 18.0258 15.3135 18 15 18C13.2278 18 11.6709 18.8238 10.7829 21H5C4.44772 21 4 20.5523 4 20C4 16.9026 4.57314 14.6574 5.65442 13.1636Z"
            fill={props.fill}
            stroke="none"
          />
        </g>
        <mask
          id="path-6-outside-1_13154_5"
          maskUnits="userSpaceOnUse"
          fill="black"
          stroke="none"
        >
          <rect fill="white" x="0" y="0" width="100%" height="100%" />
          <path
            d="M18.8789 18.777L17.7995 17.7355L16.512 19.0699L18.0859 20.0502L18.8789 18.777ZM20.3456 20.1636L19.1305 21.0432L20.3456 20.1636ZM11.6544 20.1636L10.4393 19.2841L11.6544 20.1636ZM13.1211 18.777L13.9141 20.0502L15.488 19.0699L14.2005 17.7355L13.1211 18.777ZM16 10.5C12.9624 10.5 10.5 12.9624 10.5 16H13.5C13.5 14.6193 14.6193 13.5 16 13.5V10.5ZM21.5 16C21.5 12.9624 19.0376 10.5 16 10.5V13.5C17.3807 13.5 18.5 14.6193 18.5 16H21.5ZM19.9584 19.8185C20.9114 18.8307 21.5 17.4825 21.5 16H18.5C18.5 16.6747 18.2347 17.2844 17.7995 17.7355L19.9584 19.8185ZM18.0859 20.0502C18.4567 20.2812 18.811 20.6018 19.1305 21.0432L21.5607 19.2841C21.0214 18.5391 20.3838 17.9472 19.672 17.5038L18.0859 20.0502ZM19.1305 21.0432C19.947 22.1712 20.5 24.0485 20.5 27H23.5C23.5 23.7567 22.9067 21.1436 21.5607 19.2841L19.1305 21.0432ZM20.5 27C20.5 26.7239 20.7239 26.5 21 26.5V29.5C22.3807 29.5 23.5 28.3807 23.5 27H20.5ZM21 26.5H11V29.5H21V26.5ZM11 26.5C11.2761 26.5 11.5 26.7239 11.5 27H8.5C8.5 28.3807 9.61929 29.5 11 29.5V26.5ZM11.5 27C11.5 24.0485 12.053 22.1712 12.8695 21.0432L10.4393 19.2841C9.09332 21.1436 8.5 23.7567 8.5 27H11.5ZM12.8695 21.0432C13.189 20.6018 13.5433 20.2812 13.9141 20.0502L12.328 17.5038C11.6162 17.9472 10.9786 18.5391 10.4393 19.2841L12.8695 21.0432ZM10.5 16C10.5 17.4825 11.0886 18.8307 12.0416 19.8185L14.2005 17.7355C13.7653 17.2844 13.5 16.6747 13.5 16H10.5Z"
            mask="url(#path-6-outside-1_13154_6)"
          />
        </mask>
        <mask
          id="path-6-outside-1_13154_6"
          maskUnits="userSpaceOnUse"
          x="8"
          y="10"
          width="16"
          height="20"
          fill="black"
        >
          <rect fill="white" x="8" y="10" width="16" height="20" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 16C12 13.7909 13.7909 12 16 12C18.2091 12 20 13.7909 20 16C20 17.0786 19.5731 18.0576 18.8789 18.777C19.4203 19.1142 19.9162 19.5705 20.3456 20.1636C21.4269 21.6574 22 23.9026 22 27C22 27.5523 21.5523 28 21 28H11C10.4477 28 10 27.5523 10 27C10 23.9026 10.5731 21.6574 11.6544 20.1636C12.0838 19.5705 12.5797 19.1142 13.1211 18.777C12.4269 18.0576 12 17.0786 12 16Z"
            stroke="none"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 16C12 13.7909 13.7909 12 16 12C18.2091 12 20 13.7909 20 16C20 17.0786 19.5731 18.0576 18.8789 18.777C19.4203 19.1142 19.9162 19.5705 20.3456 20.1636C21.4269 21.6574 22 23.9026 22 27C22 27.5523 21.5523 28 21 28H11C10.4477 28 10 27.5523 10 27C10 23.9026 10.5731 21.6574 11.6544 20.1636C12.0838 19.5705 12.5797 19.1142 13.1211 18.777C12.4269 18.0576 12 17.0786 12 16Z"
          fill={props.fill}
          stroke="none"
        />
      </svg>
    </IconWrapper>
  ),
};

export const GroupsIcon = (props: IconProps) => (
  <IconWrapper size={32} viewBox="0 0 32 32" {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 10.268a6 6 0 11-12 0 6 6 0 0112 0zm-6 4a4 4 0 100-8 4 4 0 000 8zm-1 8a6 6 0 11-12 0 6 6 0 0112 0zm-6 4a4 4 0 100-8 4 4 0 000 8zm14 2a6 6 0 100-12 6 6 0 000 12zm4-6a4 4 0 11-8 0 4 4 0 018 0z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

GroupsIcon.Outline = GroupsIcon;

GroupsIcon.Filled = (props: IconProps) => (
  <IconWrapper size={32} viewBox="0 0 32 32" {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 16a6 6 0 100-12 6 6 0 000 12zM9 28a6 6 0 100-12 6 6 0 000 12zm14 0a6 6 0 100-12 6 6 0 000 12z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const MeIcon = (props: IconProps) => (
  <IconWrapper size={32} viewBox="0 0 32 32" {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12zm10-12c0 5.523-4.477 10-10 10S6 21.523 6 16 10.477 6 16 6s10 4.477 10 10zm-5.05 4.95a1 1 0 10-1.415-1.415 5 5 0 01-7.07 0 1 1 0 00-1.415 1.415 7 7 0 009.9 0z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

MeIcon.Outline = MeIcon;

MeIcon.Filled = (props: IconProps) => (
  <IconWrapper size={32} viewBox="0 0 32 32" {...props}>
    <svg>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28 16c0 6.627-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4s12 5.373 12 12zm-7.05 4.95a1 1 0 10-1.415-1.415 5 5 0 01-7.07 0 1 1 0 00-1.415 1.415 7 7 0 009.9 0z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);

export const DashboardIcon = (props: IconProps) => (
  <IconWrapper size={32} viewBox="0 0 32 32" {...props}>
    <svg>
      <path
        d="M9 17a1 1 0 112 0v1a1 1 0 11-2 0v-1zM18 15a1 1 0 00-1 1v2a1 1 0 102 0v-2a1 1 0 00-1-1zM13 12a1 1 0 112 0v6a1 1 0 11-2 0v-6zM22 13a1 1 0 00-1 1v4a1 1 0 102 0v-4a1 1 0 00-1-1z"
        fill={props.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.554 6c-.239 0-.523 0-.774.02-.29.024-.706.085-1.142.307a3 3 0 00-1.311 1.311A3.016 3.016 0 004.02 8.78C4 9.031 4 9.316 4 9.554v10.892c0 .238 0 .523.02.774.024.29.085.706.307 1.142a3 3 0 001.311 1.311c.436.222.852.283 1.142.307.251.02.535.02.774.02h16.892c.238 0 .523 0 .774-.02.29-.024.706-.085 1.142-.307a3 3 0 001.311-1.311c.222-.436.283-.852.307-1.142.02-.251.02-.535.02-.774V9.554c0-.238 0-.523-.02-.774a3.015 3.015 0 00-.307-1.142 3 3 0 00-1.311-1.311 3.016 3.016 0 00-1.142-.307C24.969 6 24.685 6 24.446 6H7.554zM6 9.6c0-.56 0-.84.109-1.054a1 1 0 01.437-.437C6.76 8 7.04 8 7.6 8h16.8c.56 0 .84 0 1.054.109a1 1 0 01.437.437C26 8.76 26 9.04 26 9.6v10.8c0 .56 0 .84-.109 1.054a1 1 0 01-.437.437C25.24 22 24.96 22 24.4 22H7.6c-.56 0-.84 0-1.054-.109a1 1 0 01-.437-.437C6 21.24 6 20.96 6 20.4V9.6z"
        fill={props.fill}
      />
      <path d="M10 25a1 1 0 100 2h12a1 1 0 100-2H10z" fill={props.fill} />
    </svg>
  </IconWrapper>
);

DashboardIcon.Outline = DashboardIcon;

DashboardIcon.Filled = (props: IconProps) => (
  <IconWrapper size={32} viewBox="0 0 32 32" {...props}>
    <svg>
      <path
        d="M9 26a1 1 0 011-1h12a1 1 0 110 2H10a1 1 0 01-1-1z"
        fill={props.fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.78 6.02C7.031 6 7.315 6 7.554 6h16.892c.238 0 .523 0 .774.02.29.024.706.085 1.142.307a3 3 0 011.311 1.311c.222.436.283.852.307 1.142.02.251.02.536.02.774v10.892c0 .238 0 .523-.02.774-.024.29-.085.706-.307 1.142a3 3 0 01-1.311 1.311 3.017 3.017 0 01-1.142.307c-.251.02-.535.02-.774.02H7.554c-.239 0-.523 0-.774-.02a3.017 3.017 0 01-1.142-.307 3 3 0 01-1.311-1.311 3.016 3.016 0 01-.307-1.142C4 20.969 4 20.685 4 20.446V9.554c0-.238 0-.523.02-.774.024-.29.085-.706.307-1.142a3 3 0 011.311-1.311A3.016 3.016 0 016.78 6.02zM14 11a1 1 0 00-1 1v6a1 1 0 102 0v-6a1 1 0 00-1-1zm3 5a1 1 0 112 0v2a1 1 0 11-2 0v-2zm-7 0a1 1 0 00-1 1v1a1 1 0 102 0v-1a1 1 0 00-1-1zm11-2a1 1 0 112 0v4a1 1 0 11-2 0v-4z"
        fill={props.fill}
      />
    </svg>
  </IconWrapper>
);
